import React from 'react';
import { translate } from 'react-i18next';

import ScheduleAvailableShiftsCounter from 'components/ScheduleAvailableShiftsCounter';
import ScheduleExchangeShiftsCounter from 'components/ScheduleExchangeShiftsCounter';
import ScheduleNotificationCounter from 'components/ScheduleNotificationCounter';
import ScheduleSidebar from 'components/ScheduleSidebar';
import ScheduleSelectedDay from 'components/ScheduleSelectedDay';
import ScheduleCalendar from 'components/ScheduleCalendar';
import UIStatusDialog from 'components/UIStatusDialog';
import CalendarView from 'CalendarView';

import EmployeeActions from 'actions/EmployeeActions.js';
import AccountActions from 'actions/AccountActions.js';

class ScheduleView extends React.Component {
  constructor(props) {
    super(props);
    this.clearCalendar(false);
    this.calendarView = null;
    this.exchangeDaySelectMode = false;
    this.clearDeeplinkShift = false;

    this.onDaySelect = this.onDaySelect.bind(this);
    this._updatedUnavailabilities = this._updatedUnavailabilities.bind(this);
    this.clearSelectedShiftId = this.clearSelectedShiftId.bind(this);
    this.currentSelectedDay = null;
  }

  clearCalendar(set = true) {
    if (!this.exchangeDaySelectMode) {
      this.selectedShiftId = null;
      this.shiftData = {};
      this.scheduledShifts = {};
      this.offeredShifts = {};
      this.unavailableShifts = {};
      this.availableShifts = {};
      this.unavailableRequests = {};
      this.unavailableTypes = {};
      this.availableExchanges = {};
      this.availableExchangeUsers = {};
      this.openSidebar = false;
      this.exchangeType = 'exchange';
      this.selectedExchangeShift = null;
      this.sideBarToggled = false;
      this.selectedExchangeDays = [];
      this.exchangeDaySelectMode = false;
      this.currentSelectedDay = null;

      this.shiftsFetched = false;
      this.unavailablesFetched = false;
      this.unavailableTypesFetched = false;
      this.availablesFetched = false;
      this.exchangesFetched = false;
      this.allExchangesFetched = false;
      this.deeplinked = false;

      this.setSideBarOverflow = this.setSideBarOverflow.bind(this);

      const days = document.querySelectorAll('.month .day');
      [].forEach.call(days, (day) => {
        day.classList.remove('active');
        day.classList.remove('exchanged');
      });
      if (set) {
        this.setState({
          exchangeNotificationCount: 0,
          deeplinked: false,
          selectedShiftId: this.props.params.id,
          shiftData: null,
          scheduledShifts: null,
          offeredShifts: null,
          unavailableShifts: null,
          availableShifts: null,
          unavailableRequests: null,
          unavailableTypes: null,
          availableExchanges: null,
          availableExchangeUsers: null,
          selectedDayData: null,
          selectedExchangeDays: null,
          selectedDay: null,
          openSidebar: false,
          exchangeType: 'exchange',
          selectedExchangeShift: null,
          exchangeDaySelectMode: false,
          statuses: [],
        });
      } else {
        this.state = {
          deeplinked: false,
          selectedShiftId: null,
          shiftData: null,
          scheduledShifts: null,
          offeredShifts: null,
          availableShifts: null,
          unavailableShifts: null,
          unavailableRequests: null,
          unavailableTypes: null,
          availableExchanges: null,
          availableExchangeUsers: null,
          selectedDayData: null,
          selectedExchangeDays: null,
          selectedDay: null,
          openSidebar: false,
          exchangeType: 'exchange',
          selectedExchangeShift: null,
          exchangeDaySelectMode: false,
          statuses: [],
        };
      }
    }
  }

  clearSelectedShiftId() {
    if (this.state.selectedShiftId != null) {
      this.setState({
        selectedShiftId: null,
      });
      Utils.getBrowserHistory().push('/schedule');
    }
  }

  componentDidMount() {
    const that = this;

    AccountActions.getCoreAccount();

    ShiftStore.on(
      'shift:deeplink',
      function (shift_id, shiftDate) {
        const startDate = moment(Utils.getCurrentDate())
          .startOf('month')
          .format();
        const endDate = moment(Utils.getCurrentDate())
          .endOf('month')
          .format();
        var shiftDate = moment(shiftDate);
        if (!shiftDate.isBetween(startDate, endDate)) {
          this.calendarView.gotoDate(shiftDate, true);
        }
      },
      this,
    );

    if (ShiftStore) {
      ShiftStore.on(appConstants.ActionTypes.CLEAR_CALENDAR, () => {
        () => that.clearCalendar;
      });

      const today = moment(Date.now());
      this.calendarView = new CalendarView(today);

      // store event handler for initial data load
      ShiftStore.on(
        'shifts:load:success',
        function () {
          const startDate = moment(Utils.getCurrentDate())
            .startOf('month')
            .format(); // moment(new Date(parseInt(moment(Utils.getCurrentDate()).format('Y')), parseInt(moment(Utils.getCurrentDate()).format('M')), 1)).format();
          const endDate = moment(startDate)
            .endOf('month')
            .format();
          this.shiftData = ShiftStore.getAllShifts(startDate, endDate);
          this.offeredShifts = OffersStore.getAllOfferedShifts(startDate, endDate);
          this.scheduledShifts = ShiftStore.getAllShifts(startDate, endDate);

          if (!Utils.isNotDefined(this.props.params.id) && this.deeplinked) {
            this.deeplinked = false;
            const data = OffersStore.getAvailableShiftByID(this.props.params.id);
            this.calendarView.gotoDate(data.date);
          }

          this.shiftsFetched = true;
          this.isAllFetched();
        },
        this,
      );

      ShiftStore.on('shifts:load:error', this.dataErrorHandler, this);
    }

    if (UnavailablesStore) {
      UnavailablesStore.on(
        'unavailables:load:success',
        function () {
          this.unavailableShifts = UnavailablesStore.getAllUnavailables();
          this.unavailableRequests = UnavailablesStore.getAllUnavailableRequests();
          this.unavailablesFetched = true;
          this.isAllFetched();
        },
        this,
      );

      UnavailablesStore.on(
        'unavailables:create:success',
        function (collection, id) {
          const startDate = moment(Utils.getCurrentDate())
            .startOf('month')
            .format();
          const endDate = moment(startDate)
            .endOf('month')
            .format();
          EmployeeActions.getUnavailables(startDate, endDate);
          UnavailablesStore.on('unavailables:load:success', this._updatedUnavailabilities);
        },
        this,
      );

      UnavailablesStore.on('unavailables:load:error', this.dataErrorHandler, this);

      UnavailablesStore.on(
        'unavailables:cancel:success',
        function (model, response, startDate, endDate) {
          this.unavailableShifts = UnavailablesStore.getAllUnavailables();
          this.setState({
            unavailableShifts: UnavailablesStore.getAllUnavailables(),
          });
        },
        this,
      );
    }

    if (AvailabilitiesStore) {
      AvailabilitiesStore.on(
        'availables:load:success',
        function (response) {
          this.availableShifts = AvailabilitiesStore.getAllAvailables();

          this.availablesFetched = true;
          this.isAllFetched();
        },
        this,
      );

      AvailabilitiesStore.on(
        'availability:delete:success',
        function (collection, response) {
          const len = this.state.selectedDayData.availableShifts.length;
          for (let i = 0; i < len; i++) {
            if (this.state.selectedDayData.availableShifts[i].id == collection.id) {
              this.state.selectedDayData.availableShifts.splice(i, 1);
              if (this.state.selectedDayData.availableShifts.length == 0) {
                this.state.selectedDayData.availableShifts = undefined;
              }
              break;
            }
          }

          this.availableShifts = AvailabilitiesStore.getAllAvailables();

          this.setState({
            selectedDayData: this.state.selectedDayData,
            availableShifts: this.availableShifts,
          });
        },
        this,
      );

      AvailabilitiesStore.on(
        'availability:create:success',
        function (collection, response) {
          if (
            this.state.selectedDayData
            && this.state.selectedDayData.availableShifts
            && this.state.selectedDayData.availableShifts.length > 0
          ) {
            this.state.selectedDayData.availableShifts.push(
              AvailabilitiesStore.get(response.data.availability.id).present(),
            );
          } else {
            this.state.selectedDayData.availableShifts = [];
            this.state.selectedDayData.availableShifts.push(
              AvailabilitiesStore.get(response.data.availability.id).present(),
            );
          }

          this.availableShifts = AvailabilitiesStore.getAllAvailables();
          this.setState({
            availableShifts: AvailabilitiesStore.getAllAvailables(),
          });
        },
        this,
      );

      if (!Utils.isNotDefined(this.props.params.id)) {
        this.deeplinked = true;
        this.setState({
          deeplinked: true,
        });
        this.calendarView.getSixMonthsOfData();
      } else {
        this.calendarView.initializeCalendar(moment(Date.now()).toDate());
      }
    }

    if (UnavailableTypesStore) {
      UnavailableTypesStore.on(
        'unavailable_types:load:success',
        function () {
          this.unavailablesTypes = UnavailableTypesStore.getAllUnavailableTypes();
          this.unavailableTypesFetched = true;
          this.isAllFetched();
        },
        this,
      );
    }

    if (UserStore) {
      UserStore.on(
        'user:shared:sent:calendar:success',
        function (collection, response) {
          this.state.statuses.push({
            title: this.props.t('ScheduleView.success'),
            message: 'Your schedule has been sent to blah@blah.com.',
            status: 'success',
            key: _.uniqueId(),
          });
          this.setState({
            statuses: this.state.statuses,
          });
        },
        this,
      );
    }

    if (ExchangesStore) {
      ExchangesStore.on(
        'exchanges:post:advertisment:success',
        function (collection, response) {
          const startDate = moment(Utils.getCurrentDate())
            .startOf('month')
            .format();
          const endDate = moment(startDate)
            .endOf('month')
            .format();
          const shifts = ShiftStore.getAllShiftsUntilTheEndOfTime();
          const exchanges = ExchangesStore.getAllExchangesUntilTheEndOfTime();
          this.setState({
            exchangeNotificationCount: exchanges.length,
          });

          this.availableExchanges = ExchangesStore.getAllExchanges(startDate, endDate);
        },
        this,
      );

      ExchangesStore.on(
        'exchanges:bid:advertisment:success',
        function (collection, response, exchange) {
          this.toggleOpenSidebar();

          const startDate = moment(Utils.getCurrentDate())
            .startOf('month')
            .format();
          const startDateToday = moment(new Date()).format();
          const beginingOfTime = moment([1980, 0, 1]).format();
          const endDate = moment(startDate)
            .endOf('month')
            .format();
          const endOfTime = moment(new Date())
            .add(1, 'year')
            .format();

          if (EmployeeActions) {
            EmployeeActions.getExchanges(startDate, endDate);
            EmployeeActions.getAllExchanges(startDateToday, endOfTime);
          }

          /*
        var startDate = moment(Utils.getCurrentDate()).startOf('month').format();
        var endDate = moment(startDate).endOf('month').format();
        this.availableExchanges = ExchangesStore.getAllExchanges(startDate, endDate);
        */

          let shiftType = 'exchange';
          if (exchange.drop || exchange.drop === 'true') {
            shiftType = 'drop';
          }

          this.state.statuses.push({
            title: this.props.t('ScheduleView.success'),
            message: this.props.t('ScheduleView.submitted_for_approval', { shiftType }),
            status: 'success',
            key: _.uniqueId(),
          });
          this.setState({
            statuses: this.state.statuses,
          });
        },
        this,
      );

      ExchangesStore.on('exchanges:bid:advertisment:error', this.dataErrorHandler, this);

      ExchangesStore.on(
        'exchanges:cancel:advertisment:success',
        function (collection, response) {
          const startDate = moment(Utils.getCurrentDate())
            .startOf('month')
            .format(); // moment(new Date(parseInt(moment(Utils.getCurrentDate()).format('Y')), parseInt(moment(Utils.getCurrentDate()).format('M')), 1)).format();
          const endDate = moment(startDate)
            .endOf('month')
            .format();
          this.availableExchanges = ExchangesStore.getAllExchanges(startDate, endDate);
          this.shiftData = ShiftStore.getAllShifts(startDate, endDate);
          this.scheduledShifts = ShiftStore.getAllShifts(startDate, endDate);
          this.offeredShifts = OffersStore.getAllOfferedShifts(startDate, endDate);
          if (this.openSidebar) this.toggleOpenSidebar();
          if (!Utils.isNotDefined(this.state.selectedDayData.scheduledShifts)) {
            const len = this.state.selectedDayData.scheduledShifts.length;
            let found = false;
            for (let i = 0; i < len; i++) {
              const { shift_id } = this.state.selectedDayData.scheduledShifts[i];
              const { exchanges } = this.state.selectedDayData.scheduledShifts[i];
              const xlen = exchanges.length;
              for (let x = 0; x < xlen; x++) {
                const exchange_id = !Utils.isNotDefined(
                  this.state.selectedDayData.scheduledShifts[i].exchanges[x],
                )
                  ? this.state.selectedDayData.scheduledShifts[i].exchanges[x].id
                  : this.state.selectedDayData.scheduledShifts[i].exchanges[x].id;

                const checkID = !Utils.isNotDefined(collection.models)
                  ? collection.models[0].id
                  : collection.id;
                if (exchange_id == checkID) {
                  found = true;
                  this.state.selectedDayData.scheduledShifts[i].exchanges.splice(x, 1);
                  if (this.state.selectedDayData.scheduledShifts[i].exchanges.length == 0) {
                    this.state.selectedDayData.scheduledShifts[i].exchange = undefined;
                  }
                  break;
                }
              }
              if (found) {
                break;
              }
            }
          }

          this.setState({
            selectedDayData: this.state.selectedDayData,
          });
        },
        this,
      );

      ExchangesStore.on(
        'all:exchanges:load:success',
        function () {
          const startDate = moment(Utils.getCurrentDate())
            .startOf('month')
            .format();
          const endDate = moment(startDate)
            .endOf('month')
            .format();

          this.availableExchanges = ExchangesStore.getAllExchanges(startDate, endDate);

          this.allExchangesFetched = true;
          this.isAllFetched();
        },
        this,
      );

      ExchangesStore.on(
        'exchanges:load:success',
        function () {
          const startDate = moment(Utils.getCurrentDate())
            .startOf('month')
            .format();
          const endDate = moment(startDate)
            .endOf('month')
            .format();

          // this.availableExchanges = ExchangesStore.getAllExchanges(startDate, endDate);

          this.exchangesFetched = true;
          this.isAllFetched();
        },
        this,
      );

      ExchangesStore.on('exchanges:load:error', this.dataErrorHandler, this);
    }

    if (BidsStore) {
      BidsStore.on(
        'exchanges:post:bids:success',
        function (collection, response) {
          this.toggleOpenSidebar();
          this.selectedExchangeDays = [];
          this.state.statuses.push({
            title: this.props.t('ScheduleView.success'),
            message: this.props.t('ScheduleView.bid_shift_success'),
            status: 'success',
            key: _.uniqueId(),
          });
          this.setState({
            statuses: this.state.statuses,
            selectedExchangeDays: this.selectedExchangeDays,
          });

          const today = moment(Date.now());
          const startDate = moment(
            new Date(parseInt(today.format('Y')), parseInt(today.format('M')), 1),
          ).format();
          const beginingOfTime = moment([1980, 0, 1]).format();
          const endDate = moment(startDate)
            .endOf('month')
            .format();

          if (EmployeeActions) {
            EmployeeActions.getExchanges(startDate, endDate);
          }
        },
        this,
      );

      BidsStore.on(
        'exchanges:post:bid:drop:success',
        function (collection, response) {
          this.toggleOpenSidebar();

          this.state.statuses.push({
            title: this.props.t('ScheduleView.success'),
            message: this.props.t('ScheduleView.bid_dropped_shift_success'),
            status: 'success',
            key: _.uniqueId(),
          });
          this.setState({
            statuses: this.state.statuses,
          });
        },
        this,
      );

      BidsStore.on(
        'bids:destroy:success',
        function () {
          this.toggleOpenSidebar();
          this.state.statuses.push({
            title: this.props.t('ScheduleView.success'),
            message: this.props.t('ScheduleView.cancelled_offer_success'),
            status: 'success',
            key: _.uniqueId(),
          });
          this.setState({
            statuses: this.state.statuses,
          });
        },
        this,
      );

      BidsStore.on('bids:destroy:error', this.dataErrorHandler, this);
      BidsStore.on('exchanges:post:bids:error', this.dataErrorHandler, this);
    }

    // lame page title hack, probably a better way to do this in routes.
    if (this.props && this.props.title) document.title = this.props.title;
  }

  dataErrorHandler(collection, response) {
    if (response.responseText) {
      var error = JSON.parse(response.responseText);
      this.state.statuses.push({
        title: this.props.t('ScheduleView.error'),
        message: error.error_message,
        status: 'error',
        key: _.uniqueId(),
      });
    } else if (response.statusText === 'error') {
      // error handling here
      this.state.statuses.push({
        title: this.props.t('ScheduleView.error'),
        message: response.error_message || response.responseText.error_message,
        status: 'error',
        key: _.uniqueId(),
      });
    } else if (response == 'error') {
      var error = JSON.parse(collection.responseText);
      this.state.statuses.push({
        title: this.props.t('ScheduleView.error'),
        message: error.error_message,
        status: 'error',
        key: _.uniqueId(),
      });
    }
    this.setState({
      statuses: this.state.statuses,
    });
    Utils.removeSpinner();
  }

  isAllFetched() {
    if (
      this.shiftsFetched
      && this.unavailablesFetched
      && this.availablesFetched
      && this.exchangesFetched
      && this.allExchangesFetched
      && this.unavailableTypesFetched
    ) {
      this.shiftsFetched = false;
      this.unavailablesFetched = false;
      this.availablesFetched = false;
      this.exchangesFetched = false;
      this.allExchangesFetched = false;
      this.unavailableTypesFetched = false;

      this.clearCalendar();
      this.pushLocalToState();
      Utils.removeSpinner();
    }
  }

  pushLocalToState() {
    const startDate = moment(Utils.getCurrentDate())
      .startOf('month')
      .format();
    const endDate = moment(startDate)
      .endOf('month')
      .format();
    const allShifts = ShiftStore.getAllShifts(startDate, endDate);
    let offerableShifts;
    if (this.state.exchangeDaySelectMode) {
      offerableShifts = ShiftStore.getOfferableShifts(this.state.selectedExchangeShift);
    }

    this.setState({
      shiftData: ShiftStore.getAllShifts(startDate, endDate),
      scheduledShifts: offerableShifts || allShifts,
      offeredShifts: OffersStore.getAllOfferedShifts(startDate, endDate),
      availableShifts: AvailabilitiesStore.getAllAvailables(),
      unavailableShifts: UnavailablesStore.getAllUnavailables(),
      unavailableRequests: UnavailablesStore.getAllUnavailableRequests(),
      unavailableTypes: UnavailableTypesStore.getAllUnavailableTypes(),
      availableExchangeUsers: ExchangesStore.getAllExchangeUsers(),
      availableExchanges: ExchangesStore.getAllExchanges(startDate, endDate),
    });

    setTimeout(this.calendarView.resetInitial, 500);

    if (!this.clearDeeplinkShift) {
      this.clearDeeplinkShift = true;
    } else {
      this.clearSelectedShiftId();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params && nextProps.params.id) {
      this.setState({
        selectedShiftId: nextProps.params.id,
      });
    }
  }

  componentWillUnmount() {
    // remove store event handlers
    ShiftStore.off(null, null, this);
    AvailabilitiesStore.off(null, null, this);
    UnavailablesStore.off(null, null, this);
    UnavailableTypesStore.off(null, null, this);
    ExchangesStore.off(null, null, this);
    BidsStore.off(null, null, this);
    UserStore.off(null, null, this);
  }

  setExchangeDaySelectMode(bool, overlapShifts) {
    this.exchangeDaySelectMode = bool;

    const activeExchangeMode = document.querySelector('.month .week .day.active.exchange-mode');
    if (activeExchangeMode) {
      activeExchangeMode.classList.remove('exchange-mode');

      const selectedDays = document.querySelectorAll('.month .week .day.selected');
      [].forEach.call(selectedDays, (el) => {
        el.classList.remove('selected');
      });

      this.selectedExchangeDays = [];
      this.setState({
        selectedExchangeDays: null,
        exchangeDaySelectMode: bool,
      });
    }
    this.setState({
      exchangeDaySelectMode: bool,
    });
    if (bool) {
      if (!_.isUndefined(overlapShifts)) {
        const shiftName = overlapShifts[0].name || '';
        this.state.statuses.push({
          title: this.props.t('ScheduleView.overlapping_shift'),
          message: this.props.t('ScheduleView.overlapping_shift_error', {
            shiftName,
            date: moment(overlapShifts[0].start_time).tz(overlapShifts[0].time_zone).format('ddd MMM D, YYYY')
          }),
          status: 'error',
          key: _.uniqueId(),
        });
        this.addSelectedDay([overlapShifts[0]], true);
      } else {
        this.state.statuses.push({
          title: this.props.t('ScheduleView.select_up_to_three'),
          message: '',
          status: 'success',
          key: _.uniqueId(),
        });
      }
      const eligibleOfferShifts = ShiftStore.getOfferableShifts(this.selectedExchangeShift);

      this.setState({
        statuses: this.state.statuses,
        exchangeDaySelectMode: bool,
        exchangeableShifts: this.state.selectedDayData.scheduledShifts,
        scheduledShifts: eligibleOfferShifts,
      });

      document.querySelector('.month .week .day.active').classList.add('exchange-mode');
    }
  }

  onDaySelect(data, date, selected, target) {
    const that = this;

    this.setState({
      openCoworkerSidebar: false
    });

    if (target) {
      this.currentSelectedDay = target;
    }

    if (!that.exchangeDaySelectMode) {
      if (data != null) {
        this.selectedExchangeShift = null;
        setTimeout(() => {
          that.setSideBarOverflow();
        }, 500);
        this.setState({
          selectedDayData: data,
          selectedDay: date,
          selectedExchangeShift: null,
        });
      }
    } else {
      let selectable = true;
      if (data != null) {
        const dataParse = !Utils.isNotDefined(data.scheduledShifts)
          ? data.scheduledShifts
          : [data.present()];
        if (selected) {
          if (this.selectedExchangeDays.length < 3) {
            if (dataParse) {
              that.addSelectedDay(dataParse);
            } else {
              selectable = false;
            }
          } else {
            this.state.statuses.push({
              title: this.props.t('ScheduleView.select_up_to_three_error'),
              message: '',
              status: 'error',
              key: _.uniqueId(),
            });
            this.setState({
              statuses: this.state.statuses,
            });
            selectable = false;
            target.classList.remove('selected');
          }
        } else {
          that.removeSelectedDay(dataParse);
        }
        if (selectable) {
          this.setState({
            selectedExchangeDays: that.selectedExchangeDays,
          });
        }
      }
    }
  }

  closeStatusDialog(props) {
    const len = this.state.statuses.length;
    for (let i = 0; i < len; i++) {
      if (props.status.key == this.state.statuses[i].key) {
        this.state.statuses.splice(i, 1);
        break;
      }
    }
    this.setState({
      statuses: this.state.statuses,
    });
  }

  addSelectedDay(data, overlap) {
    if (data) {
      const len = data.length;
      for (let i = 0; i < len; i++) {
        if (!this.selectedDayAlreadyExist(data[i].id)) {
          this.selectedExchangeDays.push({ overlap, data: data[i] });
        }
      }
      this.setState({
        selectedExchangeDays: this.selectedExchangeDays,
      });
    }
  }

  removeSelectedDay(data) {
    const lenx = data.length;
    for (let x = 0; x < lenx; x++) {
      const len = this.selectedExchangeDays.length;
      for (let i = 0; i < len; i++) {
        if (this.selectedExchangeDays[i].data.id == data[x].id) {
          this.selectedExchangeDays.splice(i, 1);
          break;
        }
      }
    }
    this.setState({
      selectedExchangeDays: this.selectedExchangeDays,
    });
  }

  removeAllSelectedDays() {
    this.selectedExchangeDays = [];
    this.setState({
      selectedExchangeDays: this.selectedExchangeDays,
    });
  }

  selectedDayAlreadyExist(id) {
    let exists = false;
    const len = this.selectedExchangeDays.length;
    for (let i = 0; i < len; i++) {
      if (this.selectedExchangeDays[i].data.id == id) {
        exists = true;
        break;
      }
    }
    return exists;
  }

  setSideBarOverflow() {
    const side = document.querySelector('aside.open');
    if (!Utils.isNotDefined(side)) {
      side.classList.remove('open');
      this.setExchangeDaySelectMode(false);
    }
  }

  _extractOverlappingShifts(shifts, exchange) {
    const overlappedShifts = [];
    if (_.isEmpty(shifts) || exchange.drop) {
      return overlappedShifts;
    }
    const len = shifts.length;
    const valid = true;
    for (let i = 0; i < len; i++) {
      const shift = shifts[i];
      const selectedShiftStart = moment(shift.start_time).tz(shift.time_zone);
      const selectedShiftEnd = moment(shift.end_time).tz(shift.time_zone);
      const shiftRange = moment.range(
        moment(selectedShiftStart.toDate()),
        moment(selectedShiftEnd.toDate()),
      );
      const exchangerStart = moment(exchange.shift_details.start_time).tz(
        exchange.shift_details.time_zone,
      );
      const exchangerEnd = moment(exchange.shift_details.end_time).tz(
        exchange.shift_details.time_zone,
      );
      const exchangeRange = moment.range(
        moment(exchangerStart.toDate()),
        moment(exchangerEnd.toDate()),
      );
      const isBetween = shiftRange.overlaps(exchangeRange);

      if (isBetween) {
        overlappedShifts.push(shift);
      }
    }
    return overlappedShifts;
  }

  _checkForExchangeOverlap(exchange, shifts) {
    if (_.isEmpty(shifts) || exchange.drop) {
      return true;
    }
    const len = shifts.length;
    let valid = true;
    for (let i = 0; i < len; i++) {
      const shift = shifts[i];
      const selectedShiftStart = moment(shift.start_time).tz(shift.time_zone);
      const selectedShiftEnd = moment(shift.end_time).tz(shift.time_zone);
      const shiftRange = moment.range(
        moment(selectedShiftStart.toDate()),
        moment(selectedShiftEnd.toDate()),
      );
      const exchangerStart = moment(exchange.shift_details.start_time).tz(
        exchange.shift_details.time_zone,
      );
      const exchangerEnd = moment(exchange.shift_details.end_time).tz(
        exchange.shift_details.time_zone,
      );
      const exchangeRange = moment.range(
        moment(exchangerStart.toDate()),
        moment(exchangerEnd.toDate()),
      );
      const isBetween = shiftRange.overlaps(exchangeRange);

      if (isBetween) {
        valid = false;
        // break;
      }
    }
    return valid;
  }

  _mergeShiftArray(arr, shifts) {
    for (let i = 0; i < shifts.length; i++) {
      arr.push(shifts[i]);
    }
    return arr;
  }

  toggleOpenSidebar(type, shift, nomessage) {
    const that = this;
    if (!Utils.isNotDefined(shift)) {
      this.selectedExchangeShift = shift;
      if (type == 'exchange' && !nomessage && shift.state != 'accepted') {
        const selectedDays = [];

        const before = ShiftStore.getShiftsByDate(moment(shift.shift_details.start_time));
        if (before.length > 0) this._mergeShiftArray(selectedDays, before); // selectedDays.concat(before);

        const after = ShiftStore.getShiftsByDate(moment(shift.shift_details.end_time));
        if (after.length > 0) this._mergeShiftArray(selectedDays, after); // selectedDays.concat(after);

        const dayBefore = ShiftStore.getShiftsByDate(
          moment(shift.shift_details.start_time).add(-1, 'days'),
        );
        if (dayBefore.length > 0) this._mergeShiftArray(selectedDays, dayBefore); // selectedDays.concat(dayBefore);

        const dayAfter = ShiftStore.getShiftsByDate(
          moment(shift.shift_details.end_time).add(1, 'days'),
        );
        if (dayAfter.length > 0) this._mergeShiftArray(selectedDays, dayAfter); // selectedDays.concat(dayAfter);

        if (
          selectedDays.length > 0
          && !this._checkForExchangeOverlap(this.selectedExchangeShift, selectedDays)
        ) {
          this.setExchangeDaySelectMode(true, this._extractOverlappingShifts(selectedDays, shift));
        } else {
          this.setExchangeDaySelectMode(true);
        }
      }
      this.setState({
        selectedExchangeShift: shift,
      });
    } else {
      this.selectedExchangeShift = null;
      this.setState({
        selectedExchangeShift: null,
        scheduledShifts: ShiftStore.getAllShifts(),
      });
      this.setExchangeDaySelectMode(false);
    }
    const side = document.querySelector('aside');
    const open = document.querySelector('aside.open');
    if (open && !this.openSidebar) {
      this.openSidebar = true;
    }
    if (this.openSidebar) {
      // not a fan of using js here, not possible to set up transition-delay
      // on overflow property so JS it is.
      setTimeout(() => {
        that.setSideBarOverflow();
      }, 500);
      this.openSidebar = false;
      this.exchangeType = type;
      this.sideBarToggled = true;
      this.removeAllSelectedDays();
      this.setState({
        openSidebar: false,
        exchangeType: type,
      });
    } else {
      this.openSidebar = true;
      this.exchangeType = type;
      this.sideBarToggled = true;
      this.setState({
        openSidebar: true,
        exchangeType: type,
      });
      side.classList.add('open');
    }
  }

  toggleCoworkerSidebar() {
    // This code mimics how the sidebar overflow is managed
    // in the above toggleSidebar method
    const side = document.querySelector('aside');
    if (side.classList.contains('open')) {
      setTimeout(this.setSideBarOverflow, 500);
    } else {
      side.classList.add('open');
    }

    this.setState({
      openCoworkerSidebar: !this.state.openCoworkerSidebar
    });
  }

  _updatedUnavailabilities() {
    this.unavailableShifts = UnavailablesStore.getAllUnavailables();
    this.unavailableRequests = UnavailablesStore.getAllUnavailableRequests();

    this.setState({
      unavailableShifts: this.unavailableShifts,
    });

    $(this.currentSelectedDay).trigger('click');
    UnavailablesStore.off('unavailables:load:success', this._updatedUnavailabilities);
  }

  render() {
    const that = this;

    const today = moment(Date.now());
    const month = today.format('MM');
    const year = today.format('YYYY');

    if (!this.state.exchangeDaySelectMode) {
      if (this.openSidebar && !this.sideBarToggled) {
        this.openSidebar = false;
      }
      this.sideBarToggled = false;
    }
    const startDate = moment(Utils.getCurrentDate())
      .startOf('month')
      .format(); // moment(new Date(parseInt(moment(this.calendarView.getCurrentDate()).format('Y')), parseInt(moment(this.calendarView.getCurrentDate()).format('M')), 1)).add(-1,"month").format();
    const endDate = moment(startDate)
      .endOf('month')
      .format();

    const shiftObj = {
      shiftData: this.state.scheduledShifts,
      offeredShifts: this.state.offeredShifts,
      availableData: this.state.availableShifts,
      unavailableData: this.state.unavailableShifts,
      unavailableRequests: this.state.unavailableRequests,
      availableExchanges: this.state.availableExchanges,
      availableExchangeUsers: this.state.availableExchangeUsers,
      selectedExchangeDays: this.state.selectedExchangeDays,
    };

    let selectedDate;
    if (Utils.isNotDefined(this.state.selectedDay)) {
      // by default, no selected date
      selectedDate = null;
    } else {
      selectedDate = moment(this.state.selectedDay).toDate();
    }

    const statusDialogs = [];
    for (let i = 0; i < this.state.statuses.length; i++) {
      statusDialogs.push(
        <UIStatusDialog
          status={this.state.statuses[i]}
          key={this.state.statuses[i].key}
          closeDialog={this.closeStatusDialog.bind(this)}
        />,
      );
    }

    const exchangesCount = this.state.exchangeNotificationCount;
    const { selectedShiftId } = this.state;

    let exchangesCounter = null;
    if (Utils.getCoreUser() && Utils.getCoreUser().company.allow_exchanges_and_drops) {
      exchangesCounter = (
        <ScheduleExchangeShiftsCounter
          notificationLabel={this.props.t('ScheduleView.exchanges')}
          notificationCount={exchangesCount}
          colorProperty="exchange"
        />
      );
    }

    return (
      <section id="schedule">
        <div id="calendar-header">
          <div id="calendar-header-wrapper">
            <div id="calendar-meta-container">
              <div id="month-toggle">
                <button id="previous-month" className="previous-arrow" />
                <button id="today-button">{this.props.t('ScheduleView.today').toUpperCase()}</button>
                <button id="next-month" className="next-arrow" />
              </div>
              <div id="month-label" />
              <div id="schedule-legend">
                <ScheduleAvailableShiftsCounter
                  notificationLabel={this.props.t('ScheduleView.available_shifts')}
                  notificationCount="0"
                  colorProperty="available"
                />
                {exchangesCounter}
                <ScheduleNotificationCounter
                  notificationLabel={this.props.t('ScheduleView.notifications')}
                  notificationCount="0"
                  colorProperty="notification"
                />
              </div>
            </div>
            <ScheduleSelectedDay
              date={selectedDate}
              toggleOpenSidebar={that.toggleOpenSidebar.bind(that)}
              toggleCoworkerSidebar={that.toggleCoworkerSidebar.bind(that)}
              openSidebar={that.openSidebar}
              openCoworkerSidebar={this.state.openCoworkerSidebar}
              exchangeType={this.exchangeType}
              selectedExchangeShift={this.selectedExchangeShift}
              selectedDayData={this.state.selectedDayData}
            />
          </div>
        </div>
        <div id="schedule-content-container">
          <div id="schedule-content-wrapper">
            <ScheduleCalendar
              month={month}
              year={year}
              clearSelectedShiftId={this.clearSelectedShiftId}
              allShiftActivity={shiftObj}
              onDaySelect={this.onDaySelect.bind(this)}
              setExchangeDaySelectMode={this.setExchangeDaySelectMode.bind(this)}
              exchangeDaySelectMode={this.state.exchangeDaySelectMode}
              selectedExchangeShift={this.state.selectedExchangeShift}
              selectedShift={selectedShiftId}
            />
            <ScheduleSidebar
              selectedDayData={this.state.selectedDayData}
              clearSelectedShiftId={this.clearSelectedShiftId}
              selectedDate={selectedDate}
              toggleOpenSidebar={that.toggleOpenSidebar.bind(that)}
              openSidebar={that.openSidebar}
              openCoworkerSidebar={this.state.openCoworkerSidebar}
              exchangeableShifts={this.state.exchangeableShifts}
              exchangeType={this.exchangeType}
              selectedExchangeShift={this.state.selectedExchangeShift}
              setExchangeDaySelectMode={this.setExchangeDaySelectMode.bind(this)}
              selectedExchangeDays={shiftObj.selectedExchangeDays}
              exchangeDaySelectMode={this.state.exchangeDaySelectMode}
              removeSelectedDay={this.removeSelectedDay.bind(this)}
              unavailableTypes={this.state.unavailableTypes}
            />
            {statusDialogs}
          </div>
        </div>
      </section>
    );
  }
}

export default translate()(ScheduleView);
